module.exports = __webpack_public_path__ + "img/task-2.6fe5066f.png";